import React from "react";
import { getBarcode } from '../../utils/getBarcode';
import { getCurrencySymbol } from '../../utils/getCurrencySymbol';
import { getCurrencyValue } from '../../utils/getCurrencyValue';
import { getHiddenTicket } from '../../utils/getHiddenTicket';
import { getPrintableAmount } from '../../utils/getPrintableAmount';
import { oddToString } from '../../utils/oddToString';
import { getLabel } from "../../../data/labels";

export default function MstbetHorseTicketFooter(props) {
    const ticketData = props.ticketData;
    const ticket = ticketData?.ticket?.[0];
    let typeGame = ticketData?.type_game;
    const isFixedOddType = typeGame == 'FIXEDODD';
    const isTotPsrType =  (typeGame == 'TOT' ||  typeGame == 'PSR');
	const conf = props.conf;
    const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; // TODO: add "isEstero" in configuration if "nationsAsSkin" wont be enough. In Italy no way to have two different currencies at the moment ;)
	const printAgainTerminalRec = props.printAgainTerminalRec;
    const maxWinAmount = getCurrencyValue(5000000, conf.cs.m, conf.cs.nd, conf.cs.ct);

    const terminalCopy = props.terminalCopy;
	const skinProperties = props.skinProperties;


	const clearBoth = {clear: "both"};
    const currency = getCurrencySymbol(conf.cs.ct);


    let idTicketToShow = ticket?.id_ticket;
	if(terminalCopy && skinProperties && skinProperties.hideTerminalTicket){
		idTicketToShow = getHiddenTicket(idTicketToShow);
	}

    function generateIdTicketWithBars(idTicket){
		let res = '';
		let tokens = idTicket.match(/.{1,4}/g);
		res = tokens.join("-");
		return res;
	}

    // this char will be added to the string "ID" (it means identify string of the ticket) to make clear that this receipt has been
	// print again due to technical issues.
	let charPAR = '';
	if(printAgainTerminalRec){
		let idString = getLabel('printer.plain_ticket.header.id');
		idString = (idString == null || idString === '')? 'IB' : idString;
		charPAR = idString.charAt(idString.length - 1);	
	}

    return (
        <>
        {isFixedOddType && 
            <>
             {"0" == ticketData?.ticket_type?
                <>
                    <div className='separator'></div>
                    <div className="bold">
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.total_amount')}:</div>
                        <div className="right td-40 textright">{getCurrencyValue(ticket.stake, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        <div style={clearBoth}></div>
                    </div>
                    <div>
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.total_odds')}</div>
                        <div className="right td-40 textright">{oddToString(ticket.tot_odd)}</div>
                        <div style={clearBoth}></div>
                    </div>
                    <div>
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.potential_winnings')}</div>
                        <div className="right td-40 textright">{getCurrencyValue(ticket.max_win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        <div style={clearBoth}></div>
                    </div>
                    <div className="textcenter total_win_text">{getLabel('printer.plain_ticket.footer.total_winnings')}</div>
				    <div className="textcenter total_win">{getCurrencyValue(ticket.max_win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                </>
             :
             "2" == ticketData?.ticket_type?
                <>
                    <div className='separator'></div>
                    <div className="bold">
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.system_total_amount')}:</div>
                        <div className="right td-40 textright">{getCurrencyValue(ticket.stake, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        <div style={clearBoth}></div>
                    </div>
                    {aamsEnviroment && (
                        <div >
                            <div className="left td-60">{getLabel('printer.plain_ticket.footer.winnings_limit')}</div>
                            <div className="right td-40 textright">{maxWinAmount}</div>
                            <div style={clearBoth}></div>
                        </div>
                    )
                    }
                    <div className="separator"></div>
                    <table className="combinations">
                        <tr>
                            <td className="textleft">{getLabel('printer.plain_ticket.footer.type')}</td>
                            <td className="textright">{getLabel('printer.plain_ticket.footer.combs')}</td>
                            <td className="textright">{getLabel('printer.plain_ticket.footer.bet_amount')}</td>
                            <td className="textright">{getLabel('printer.plain_ticket.footer.min_winnings')}</td>
                            <td className="textright">{getLabel('printer.plain_ticket.footer.max_winnings')}</td>
                        </tr>
                        {
                            ticket.sys.map(function(sys){
                                const reactKey = 'sys-' + sys.cod;
                                return(
                                    <tr key={reactKey} className="npla">
                                        <td className="textleft">{sys.description}</td>
                                        <td className="textright">{sys.n_combinations}</td>
                                        <td className="textright">{getPrintableAmount(sys.amount, conf.cs.m, conf.cs.nd)}</td>
                                        <td className="textright">{getPrintableAmount(sys.minWin, conf.cs.m, conf.cs.nd)}</td>
                                        <td className="textright">{getPrintableAmount(sys.maxWin, conf.cs.m, conf.cs.nd)}</td>
                                    </tr>
                                )
                            })
                        }
                    </table>
                
                    <div className="">
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.total_combs')}</div>
                        <div className="right td-40 textright">{ticket.totCombinations}</div>
                        <div style={clearBoth}></div>
                    </div>
                    <div className="">
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.min_winning_amount')}</div>
                        <div className="right td-40 textright">{getCurrencyValue(ticket.totWinMin, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        <div style={clearBoth}></div>
                    </div>
                     <div className="">
                        <div className="left td-60">{getLabel('printer.plain_ticket.footer.max_winning_amount')}</div>
                        <div className="right td-40 textright">{getCurrencyValue(ticket.totWinMax, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                        <div style={clearBoth}></div>
                    </div>
                </>
             :
                <>
                    <div className='separator'></div>
                    <div className="bold">
                        <div className="right td-40 textright">{"IMPORTO " +currency + " " + getPrintableAmount(ticket?.stake, conf.cs.m, conf.cs.nd)}</div>
                        <div style={clearBoth}></div>
                    </div>
                    <div className="textcenter total_win_text">{getLabel('printer.plain_ticket.footer.max_winning_amount')}</div>
                    <div className="textcenter total_win">{getCurrencyValue(ticket.max_win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
                </>
             }
            </>
        }

        {isTotPsrType &&
            <>
                <div className='separator'></div>
                <div className="bold">
                    <div className="right td-40 textright">{"IMPORTO " +currency + " " + getPrintableAmount(ticket?.stake, conf.cs.m, conf.cs.nd)}</div>
                    <div style={clearBoth}></div>
                </div>
            </>

        }

        <div className="textcenter id_ticket_footer">{getLabel('printer.plain_ticket.header.id') + charPAR}: {generateIdTicketWithBars(idTicketToShow)}</div>			

        <div className="barcode-top"> 
            <img style={{ height: "50px", width:"100%"}} src={getBarcode(ticket?.id_ticket, 1, false)} />
        </div>

        <div className="separator"></div>

        {
			props.terminalCopy && <>
				<div className="center disclaimer_spacing website">{conf.url}</div>			
				{
					aamsEnviroment &&(
							<div className="center disclaimer_spacing bold">
								La registrazione e l'esito della puntata effettuata possono essere verificati sul sito www.aams.it.
								<br/>
								Questo promemoria non è una ricevuta di gioco valida per la riscossione della vincita.
							</div>
					)
				}
			</>
		}
        <div className="center disclaimer_spacing bold">
            Il gioco può causare dipendenza.
            <br/>
            Consulta le probabilità di vincita su www.aams.gov.it
            <br/>
            E' vietato il gioco ai minori di anni 18
		</div>
        {/* ****************************************************************************************************************************************   
			On environments where the payment of ticket can be done on physical self (conf.rs.paysc is true ), the imprinter needs enough whitespace at the bottom of the printed ticket.
			IMPORTANT: to ensure that a whitespace is rendered on the bottom edge, this content should always be placed at the end of this component.
			To make sure that the whitespace is printend when calling window.print(), we render a <div> containing a '.' with a font size of 1px 
		*/
			conf?.rs?.paysc && <div style={{ marginTop : "35px", fontSize: "1px"}}>.</div>
		}
        </>
    )
}